// extracted by mini-css-extract-plugin
export default {"container":"w9Pkx","neutral":"xFYqY","title":"TnmLE","iconClose":"yxMSE","description":"IRJ4W","text":"WWftE","icon":"InOz5","success":"gaZK3","error":"q5zsS","content":"go0RG"};